module.exports = __webpack_public_path__ + "static/img/pete_pictgrid28_1020x874.594b96b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid28_1020x874.jpg
// module id = cB/I
// module chunks = 0